import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

const NameInputs = () => {
  const [value, setValue] = useState(null);

  const titleOptions = [
    { value: '1', label: 'Mr' },
    { value: '2', label: 'Mis' },
    { value: '3', label: 'Miss' },
    { value: '4', label: 'Md' }
  ];
  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="fw-medium">Donor Name</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Form.Group as={Col} md="6" controlId="title">
            <Form.Label className="text-600">Title</Form.Label>
            <Select
              closeMenuOnSelect={true}
              options={titleOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              value={value}
              la
              onChange={value => setValue(value)}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            md="6"
            className="d-none d-md-block"
            controlId="no"
          />
          <Form.Group as={Col} md="6" controlId="FirstName">
            <Form.Label className="text-600">First name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="First name"
              defaultValue=""
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="LastName">
            <Form.Label className="text-600">Last name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Last name"
              defaultValue=""
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default NameInputs;
